export const getAuthorNameOfPhoto = el =>
  `${el.owner.first_name} ${
    el.owner.last_name ? `${el.owner.last_name[0]}.` : ""
  }`;
